import { createFileRoute } from "@tanstack/react-router";
import SitePage from "@/components/SitePage";
import { buildHead, breadcrumbLD, touristTripLD, faqLD, SITE_URL } from "@/content/seo";

const TITLE = "Observação de Golfinhos em Vilamoura · Iate Privado · Morningstar";
const DESC = "Observação privada de golfinhos a partir de Vilamoura no Morningstar — encontros respeitosos em pequeno grupo com os golfinhos do Algarve, com paragem de mergulho e tapas portuguesas.";
const PATH = "/pt/observacao-de-golfinhos-vilamoura";
const URL = `${SITE_URL}${PATH}`;

export const Route = createFileRoute("/pt/observacao-de-golfinhos-vilamoura")({
  component: () => (
    <SitePage
      lang="pt"
      heroOverride={{
        eyebrow: "Observação de Golfinhos · Vilamoura · Algarve",
        title: "Observação privada de golfinhos em Vilamoura a bordo do ",
        titleAccent: "Morningstar.",
        sub: "Um pequeno grupo privado, aproximação lenta e o mar aberto do Algarve — encontros com golfinhos-comuns, roazes e (na primavera) golfinhos-riscados, com paragem de mergulho e tapas.",
        ctaPrimary: "Ver opções",
        ctaSecondary: "Perguntar sobre golfinhos",
      }}
    />
  ),
  head: () =>
    buildHead({
      lang: "pt",
      path: PATH,
      title: TITLE,
      description: DESC,
      keywords: "observação de golfinhos vilamoura, golfinhos algarve, passeio golfinhos vilamoura, ver golfinhos algarve",
      altPath: { en: "/dolphin-watching-vilamoura", pt: PATH },
      extraScripts: [
        {
          type: "application/ld+json",
          children: JSON.stringify(
            touristTripLD({
              name: "Private Dolphin Watching from Vilamoura",
              description: DESC,
              url: URL,
            }),
          ),
        },
        {
          type: "application/ld+json",
          children: JSON.stringify(
            breadcrumbLD([
              { name: "Início", path: "/pt" },
              { name: "Observação de Golfinhos Vilamoura", path: PATH },
            ]),
          ),
        },
        { type: "application/ld+json", children: JSON.stringify(faqLD("pt")) },
      ],
    }),
});
